import EncounterCharts from './EncounterCharts';

export default EncounterCharts;
